import { Form, InputNumber, DatePicker, Input, Button, Row, Col, Tabs, message, Modal } from 'antd';
import { useState, useRef, useEffect, forwardRef, useImperativeHandle }  from 'react';
import CustomSelect  from './CustomSelect.jsx';
import CustomCheckbox  from './CustomCheckbox.jsx';
import axiosInstance from './axiosInstance.js';
import moment from 'moment';
import './Form.css'
import {tabitem,handleException, getval, formitems} from './Utils.jsx'
import {rightitems} from './defs.js'
const { TabPane } = Tabs;
const { TextArea } = Input;



const FormLoanState = forwardRef(({entity="TLoanState", id,open,writeRight, ...props},ref)=>{

    const [form] = Form.useForm();
    const [recid, setRecid] = useState(0);
    const [loading, setLoading] = useState(true);   
    const cbFinish = useRef(null) 
    const url = '/dataservice'
    const urlsave = '/loanstatesave'
    
    useImperativeHandle(ref, () => ({
        open(id,cb=null) { if(id) loadData(id); else handleNew(); cbFinish.current = cb }
    }))

    useEffect(() => { if(id) loadData(id); else handleNew(); }, [open]);
 
    const items = [ 
        {name:"name",         label:"Jméno",required:true,       ctrl: (pp)=>(<Input {...pp}  />)}, 
    ]
    
    function translate(r,dir){
        return r      
    }

    async function loadData(recid) { 
		setRecid(recid)
        setLoading(true);	
        try {
			let response = await axiosInstance.post(url, {cmd:'get-record',entity:entity,recid:recid});
            var r = response.data.record
            r = translate(r,0)  
            form.setFieldsValue(r);        
		} catch (err) {  
            handleException(err)
		} finally {
			setLoading(false);
		}
	};

    async function saveData() {
		setLoading(true);
		try {
			const response = await axiosInstance.post(urlsave, {recid:recid, ...translate(form.getFieldsValue(),1)});
            message.success('Záznam byl úspěšně uložen');
            console.log(response)
		} catch (err) {
            handleException(err)
		} finally {
			setLoading(false);
		}
	};

    function handleChange(changedValues, allValues) { 
        //console.log('allvalues',allValues)
        console.log('changedvalues',changedValues)          
    };

    function handleNew(){
        setRecid(0)
        form.resetFields() 
    };

    function handleFinish(values){
        console.log('Form Values:', values);
        saveData();
        if(cbFinish.current) cbFinish.current(values);
    };
    
    return (
        <div>
        <Form
            form={form}
            name={'loanstateForm'}
            labelCol={{ span: 10 }}
            onFinish={handleFinish}
            onValuesChange={handleChange}
            disabled={!writeRight}
        >           
            {formitems(items)}
            
            <Form.Item wrapperCol={{ offset: 8, span: 24 }}>
                <Button type="primary" htmlType="submit">Uložit</Button>
                <Button onClick={handleNew} style={{ marginLeft: '10px' }}>Nový</Button> 
            </Form.Item>
        </Form>
        </div>
    )
})
export default FormLoanState;




